module.exports = __webpack_public_path__ + "img/Ing_Giovany_Pernia.41ebc7e2.webp";